import { render, staticRenderFns } from "./IconDESC.vue?vue&type=template&id=04473985&scoped=true&"
import script from "./IconDESC.vue?vue&type=script&lang=ts&"
export * from "./IconDESC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04473985",
  null
  
)

export default component.exports